function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  filter: "url(#blob-4_svg__filter0_d)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  clipPath: "url(#blob-4_svg__clip0)"
}, React.createElement("path", {
  opacity: 0.2,
  d: "M134.879 90.883c22.384-18.964 42.92-46.828 72.148-44.299 31.384 2.717 52.643 31.14 71.065 56.694 21.214 29.425 48.79 61.777 39.652 96.882-9.158 35.186-51.137 46.215-81.93 65.548-32.864 20.634-63.018 58.542-100.654 49.085-37.745-9.485-57.35-52.973-65.91-90.939-6.655-29.512 13.273-56.005 26.662-83.134 9.703-19.658 22.241-35.667 38.967-49.837z",
  fill: "#7C94A1"
}), React.createElement("path", {
  d: "M185.231 80.233c28.867-5.231 60.584-19.095 84.631-2.29 25.822 18.045 30.02 53.29 33.198 84.631 3.659 36.09 11.364 77.895-14.101 103.728-25.525 25.893-67.394 14.455-103.728 15.802-38.779 1.437-83.847 19.189-111.711-7.818-27.946-27.087-23.18-74.552-11.611-111.712 8.993-28.885 39.497-41.865 64.657-58.664 18.232-12.173 37.094-19.768 58.665-23.677z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("clipPath", {
  id: "blob-4_svg__clip0"
}, React.createElement("path", {
  d: "M0 0h375v375H0V0z",
  fill: "#fff"
})), React.createElement("filter", {
  id: "blob-4_svg__filter0_d",
  x: -17,
  y: 13,
  width: 393.855,
  height: 381.038,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 24
}), React.createElement("feGaussianBlur", {
  stdDeviation: 16
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0.729412 0 0 0 0 0.764706 0 0 0 0.1 0"
}), React.createElement("feBlend", {
  mode: "multiply",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

function SvgBlob4(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 375 375",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgBlob4;